<!--
  商家优惠券
  lovi 2020-07-06
-->
<template>
  <div>
    <van-popup v-model="popupFlag" get-container="body" position="bottom">
      <div class="popup-title">
        {{ $t("coupon.shopOffer") }}
        <van-icon @click="popupFlag = false" name="cross" />
      </div>
      <div class="popup-content">
        <template v-if="data.coupon && data.coupon.length">
          <div class="title">
            {{ $t("coupon.coupon") }}
          </div>
          <div class="coupon">
            <div
              class="item"
              :class="item.coupon_type == 2 ? 'item-style2' : 'item-style1'"
              v-for="(item, index) in data.coupon"
              :key="index"
            >
              <div class="item-left">
                <div
                  class="money"
                  :class="item.coupon_type == 2 ? 'text-orange' : 'text-red'"
                >
                  {{ item.coupon_amount }}P
                </div>
                <div class="info">
                  <h3>{{ item.coupon_name }}</h3>
                  <p>
                    <span
                      class="ticket"
                      :class="item.coupon_type == 2 ? 'style2' : 'style1'"
                    >
                      {{
                        item.coupon_type == 2
                          ? $t("coupon.voucher")
                          : $t("coupon.cashback")
                      }}
                    </span>
                    <span>{{ item.end_time }}</span>
                  </p>
                </div>
              </div>
              <div class="item-right">
                <span
                  :class="{
                    style2_1: item.coupon_type == 2 && item.is_receive == 1,
                    style2: item.coupon_type == 2,
                    style1_1: item.coupon_type == 1 && item.is_receive == 1,
                    style1: item.coupon_type == 1
                  }"
                  @click="clickReceive(item.is_receive, item.coupon_id)"
                >
                  {{
                    item.is_receive == 1
                      ? $t("coupon.goUse")
                      : $t("coupon.receive")
                  }}
                </span>
              </div>
              <div class="cro-wrap cro-top">
                <div class="cro left"></div>
                <div class="cro right"></div>
              </div>
              <div class="cro-wrap cro-bottom">
                <div class="cro left"></div>
                <div class="cro right"></div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="data.activity && data.activity.length">
          <div class="title">{{ $t("coupon.cashbackActivity") }}</div>
          <div class="activity">
            <p v-for="(item, index) in data.activity" :key="index">
              <span class="type">
                {{ item.activity_mk }}
              </span>
              <span>{{ item.activity_name }}</span>
            </p>
          </div>
        </template>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    couponFlag: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {
      popupFlag: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    clickReceive(isReceive, id) {
      // 领取优惠券
      if (isReceive) {
        this.$emit("update:couponFlag", false);
        return false;
      }
      this.$emit("receiveCoupons", id);
    }
  },
  watch: {
    couponFlag(bol) {
      this.popupFlag = bol;
    },
    popupFlag(bol) {
      this.$emit("update:couponFlag", bol);
    }
  }
};
</script>

<style lang="less" scoped>
.popup-title {
  position: relative;
  text-align: center;
  height: 40px;
  line-height: 39px;
  font-size: 16px;
  border-bottom: 1.1px solid #eee;
  /deep/.van-icon {
    position: absolute;
    font-size: 20px;
    top: 50%;
    margin-top: -10px;
    right: 15px;
    color: #9a9a9a;
  }
}
.popup-content {
  padding: 8px 10px;
  height: 60vh;
  background: #f4f4f4;
  overflow-y: auto;
  .title {
    font-size: 14px;
  }
}

.item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin: 8px 0;
  padding: 12px 0;
  line-height: 1;
  background: #fff;
  border: 1.1px solid #ffabb1;
  border-radius: 8px;
  &.item-style2 {
    border-color: #fe7800;
    .item-left {
      border-color: #fe7800;
    }
    .cro-wrap {
      &.cro-top {
        .left {
          border-bottom-color: #fe7800;
          border-left-color: #fe7800;
        }
        .right {
          border-bottom-color: #fe7800;
          border-right-color: #fe7800;
        }
      }
      &.cro-bottom {
        .left {
          border-top-color: #fe7800;
          border-left-color: #fe7800;
        }
        .right {
          border-top-color: #fe7800;
          border-right-color: #fe7800;
        }
      }
    }
  }
  .item-left {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;
    border-right: 1.1px dashed #ffabb1;
    .money {
      margin-right: 10px;
      width: 70px;
      text-align: center;
      font-size: 24px;
    }
    .info {
      flex: 1;
      text-align: left;
      h3 {
        font-size: 14px;
        line-height: 1;
        font-weight: 400;
      }
      p {
        margin-top: 5px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .ticket {
          margin-right: 5px;
          padding: 2px 5px;
          line-height: 1.2;
          color: #fc3c46;
          border: 1.1px solid #fc3c46;
          border-radius: 3px;
          &.style2 {
            color: #fe7800;
            border: 1.1px solid #fe7800;
          }
        }
      }
    }
  }
  .item-right {
    width: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      width: 60px;
      height: 22px;
      text-align: center;
      line-height: 22px;
      color: #fff;
      border-radius: 12px;
      background: #fd4553;
      border: 1.1px solid #fd4553;
      &.style1_1 {
        color: #fd4553;
        background: #fff;
      }
      &.style2 {
        background: #fe7800;
        border-color: #fe7800;
        &.style2_1 {
          color: #fe7800;
          background: #fff;
        }
      }
    }
  }
  .cro-wrap {
    z-index: 1;
    position: absolute;
    right: 80px;
    width: 20px;
    height: 10px;
    &.cro-top {
      top: -1.1px;
      .left {
        border-bottom-color: #ffabb1;
        border-left-color: #ffabb1;
        border-radius: 0px 0px 0px 10px;
      }
      .right {
        border-bottom-color: #ffabb1;
        border-right-color: #ffabb1;
        border-radius: 0px 0px 10px 0px;
      }
    }
    &.cro-bottom {
      bottom: -1.1px;
      .left {
        border-top-color: #ffabb1;
        border-left-color: #ffabb1;
        border-radius: 10px 0px 0px 0px;
      }
      .right {
        border-top-color: #ffabb1;
        border-right-color: #ffabb1;
        border-radius: 0px 10px 0px 0px;
      }
    }
    .cro {
      position: absolute;
      width: 10px;
      height: 10px;
      background: #f4f4f4;
      border: 1.1px solid #f4f4f4;
      &.left {
        left: 0px;
      }
      &.right {
        right: 0px;
      }
    }
  }
}

.activity {
  margin-top: 8px;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  p {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 8px;
    line-height: 1.2;
    &:first-child {
      margin-top: 0;
    }
    .type {
      margin-right: 5px;
      padding: 2px 5px;
      color: #fc3c46;
      border: 1.1px solid #fc3c46;
      border-radius: 3px;
      &.style2 {
        color: #fe7800;
        border: 1.1px solid #fe7800;
      }
    }
  }
}
</style>
